document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('header .button.done').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      var form = document.querySelector('form.form-view');
      form.submit();
    });
  });

  document.querySelectorAll('textarea').forEach(function(el) {
    var resize = function() {
      var offset = this.offsetHeight - this.clientHeight;
      this.style['height'] = '1px';
      this.style['height'] = (this.scrollHeight + offset) + 'px';
    };

    el.addEventListener('propertychange', resize);
    el.addEventListener('input', resize);

    var event = document.createEvent('HTMLEvents');
    event.initEvent('input', true, false);
    el.dispatchEvent(event);
  });

});
